import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'

export class AutoSubmitController extends Controller<HTMLFormElement> {
  static debounces = ['debouncedSubmitForm']
  static values = {
    event: { type: String, default: 'change' },
    useDebounce: { type: Boolean, default: false },
  }
  declare eventValue: string
  declare useDebounceValue: boolean

  connect(): void {
    useDebounce(this, { wait: 300 })

    this.element.addEventListener(this.eventValue, this._submitFunction)
  }

  disconnect(): void {
    this.element.removeEventListener(this.eventValue, this._submitFunction)
  }

  debouncedSubmitForm = (): void => {
    this.submitForm()
  }

  submitForm = (): void => {
    console.log('submitting form')
    this.element.requestSubmit()
  }

  get _submitFunction() {
    return this.useDebounceValue ? this.debouncedSubmitForm : this.submitForm
  }
}
